// i18n area 'vms' — locale hr-HR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.hr-HR.meta.json.
import type { enUS } from './vms'

export const hrHR: typeof enUS = {
  vms: {
    spof: {
      title: 'Neovisnost o čvoru',
      single: 'Jedina točka kvara',
      alternativesNow: 'Alternative sada',
      structural: 'Po konstrukciji',
      binding: 'Obvezujuće ograničenje',
      movableNow: 'Migracija moguća sada',
    },
    title: 'Virtualni strojevi',
    migratingChip: 'Migracija u tijeku',
    templateChip: 'Predložak',
    expendableTooltip: 'U degradiranom klasteru među prvima je koji se zaustavljaju i možda se neće ponovno pokrenuti nakon gubitka čvora.',
    expendableHaTooltip: 'Uvijek se ponovno pokreće dok je klaster ispravan; u degradiranom klasteru zaštićeni VM-ovi imaju prednost — može biti zaustavljen ili ostati isključen dok klaster ponovno ne bude cijel, a zatim se sam vraća.',
    viewDetails: 'Prikaži detalje',
    profileLegacy: 'Drugi OS',
    hugePagesNone: 'Bez velikih stranica — obična memorija',
    hugePages2M: 'Stranice od 2 MiB',
    hugePages1G: 'Stranice od 1 GiB',
    searchPlaceholder: 'Pretraži po nazivu',
    name: 'Naziv',
    vcpus: 'vCPU',
    memory: 'Memorija',
    ipAddresses: 'IP adrese',
    noIp: 'Nema IP-a',
    authorityNode: 'Authority',
    authorityNextStart: 'dodjeljuje se pri sljedećem pokretanju',
    scope: 'Scope',
    empty: 'Nema virtualnih strojeva',
    loadError: 'Virtualne strojeve nije moguće učitati — je li TVirt backend dostupan?',
    filterOverlay: 'overlay mreža',
    filterDisk: 'disk',
    filterImage: 'slika',
    filteredBy: 'Filtrirano po {kind}',
    filterPhase: 'Faza',
    filterProtection: 'Zaštita',
    filterAll: 'Sve',
    filterScopePlaceholder: 'Filtriraj po scopeu',
    filtersToggle: 'Filtri',
    scopeTree: {
      title: 'Scopeovi',
      all: 'Cijeli klaster',
      noChildren: 'Ovdje nema pod-scopeova',
      recursive: 'Uključi potomke',
      collapse: 'Sažmi ploču scopeova',
      up: 'Jednu razinu gore',
      countTooltip: 'VM-ova u ovom scopeu: {direct} · s potomcima: {total}'
    },
    isoPicker: {
      catalog: 'Katalog',
      unknownCatalog: 'Izvan vidljivih kataloga',
      noIsos: 'U ovom katalogu nema spremnih ISO slika'
    },
    actionsHeader: 'Radnje',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Hardver',
      tags: 'Tagovi',
      age: 'Starost',
      disk: 'disk',
      disks: 'diska',
      empty: 'Nema predložaka — označite isključeni VM kao predložak ili klonirajte VM kao predložak.',
      clone: 'Kloniraj / implementiraj',
      editTags: 'Uredi tagove',
      exportAction: 'Izvezi u katalog (.tvtpl)',
      exportTitle: 'Izvezi u katalog',
      exportSubmit: 'Izvezi',
      exportError: 'Izvoz nije uspio',
      exportHint: 'Predložak se pakira u arhivu .tvtpl (hardverski manifest + svaki disk spljošten u qcow2) kao nova datoteka VM predloška u odabranom katalogu. NIC-ovi, CD/DVD mediji i cloud-init ne putuju — specifikacija formata navodi svako namjerno izostavljanje.',
      exportName: 'Naziv datoteke',
      exportNameHint: 'Prazno = <template>-export-<n>',
      exportStorageDefault: 'Storage metapodataka predloška',
      importAction: 'Uvezi iz kataloga',
      importTitle: 'Uvezi iz kataloga',
      importHint: 'Datoteka VM predloška u stanju ready iz odabranog kataloga postaje predložak inventara: format datoteke (tvtpl, ova, ovf ili goli qcow2) sam odlučuje kako se uvozi — vi birate samo datoteku.',
      importFile: 'Kataloška datoteka',
      importFileHint: 'Uvoze se samo datoteke ready — datoteka usred prijenosa nije uvoziva',
      importNoFiles: 'U ovom katalogu nema datoteka VM predloška u stanju ready — najprije jednu prenesite ili izvezite'
    },
    templateDetail: {
      quickDeploy: 'Kompatibilnost s QuickDeployem',
      quickDeployNone: 'Nije deklarirana',
      quickDeployHint: 'Deklarirajte je samo ako golden slika sadrži cloud-init (Linux) ili cloudbase-init nakon sysprep /generalize (Windows): platforma vjeruje deklaraciji i nikada ne gleda unutar gosta.',
      notFound: 'Predložak nije pronađen',
      frozen: 'Hardverska konfiguracija je zamrznuta: pretvorite predložak natrag u VM da biste je izmijenili. Naziv, bilješke i tagovi ostaju izmjenjivi.',
      storage: 'Storage',
      size: 'Veličina',
      configTitle: 'Konfiguracija (zamrznuta)',
      usbClasses: 'Tražene USB klase',
      gpuClasses: 'Tražene GPU klase'
    },
    sharedDisksTab: {
      title: 'Dijeljeni diskovi',
      sharing: 'Dijeljenje',
      sharingNone: 'Jedno priključenje',
      sharingMultiwriter: 'Dijeljeno pisanje (multiwriter)',
      sharingReadonly: 'Dijeljeno samo za čitanje',
      usedBy: 'Koristi',
      attachedTo: 'Priključen na',
      notAttached: 'Nije priključen ni na jednu VM',
      changeSharing: 'Promijeni način dijeljenja',
      changeSharingTitle: 'Način dijeljenja',
      changeSharingLocked: 'Način se mijenja samo dok nijedna VM ne koristi disk',
      sharingChanged: 'Način dijeljenja ažuriran.',
      lun: 'Cijeli LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Serijski broj',
      antiAffinityWarning: 'Dva ili više članova rade na istom čvoru bez pravila anti-afiniteta: ispad jednog čvora ruši ih sve',
      antiAffinityCreate: 'Stvori pravilo',
      createSourceLun: 'Preuzmi cijeli LUN targeta',
      createLunNumber: 'Broj LUN-a (id namespacea na NVMe)',
      createLunHint: 'Ništa se ne dodjeljuje: veličina se očitava s uređaja pri preuzimanju',
      noPr: 'U ovom izdanju nema SCSI-3 persistent reservations: Windows Failover Cluster s klasičnim dijeljenim diskom nije validiran; klasteri koji se koordiniraju mrežom (GFS2/OCFS2, RHEL HA, shared-disk baze) jesu'
    },
    unusedDisksTab: {
      title: 'Nekorišteni diskovi',
      attach: 'Priključi na VM',
      attachTitle: 'Priključi na VM',
      vm: 'Virtualni stroj',
      noVms: 'Nema dostupnih VM-ova',
      noSlots: 'Nema slobodnih slotova na ovom VM-u',
      create: 'Stvori disk',
      createTitle: 'Stvori disk',
      createSourceBlank: 'Prazan disk',
      createSourceImage: 'Iz slike u katalogu',
      createImage: 'Slika',
      createImageEmpty: 'Nema spremne slike VM predloška u vidljivim katalozima',
      createSizeFromImageHint: 'Unaprijed ispunjeno virtualnom veličinom slike — može samo rasti',
      convert: 'Pretvori u VM predložak…',
      convertOnlyQcow2: 'Pretvaraju se samo qcow2 diskovi — raw nije format predloška koji se može registrirati',
      convertTitle: 'Pretvori u VM predložak',
      convertSubmit: 'Pretvori (uništava disk)',
      convertError: 'Pretvorbu nije moguće pokrenuti',
      convertWarning: 'DESTRUKTIVNO: disk postaje datoteka VM predloška u odabranom katalogu — isti storage, nula kopiranih bajtova — i PRESTAJE POSTOJATI kao disk. Povratka nema, osim stvaranjem novog diska iz predloška.',
      convertNameHint: 'Naziv kataloške datoteke — zadano je naziv samog diska',
      convertConfirm: 'Razumijem: disk će biti uništen',
      convertStarted: 'Pretvorba je pokrenuta — predložak se pojavljuje u katalogu po završetku zadatka.',
      storageLockHint: 'Storage se mijenja samo radnjom Premjesti',
      source: 'Podrijetlo',
      sourceClone: 'Klon drugog diska',
      sourceCloneLinked: 'Linked clone drugog diska',
      sourceImage: 'Stvoren iz slike',
      sourceBlank: 'Stvoren prazan',
      allocated: 'Alocirano / virtualna veličina',
      observedAt: 'Opaženo',
      snapshots: 'Snimke',
      snapshotsEmpty: 'Nema snimaka'
    },
    phase: {
      defined: 'Nikad uključen',
      starting: 'Pokreće se',
      running: 'Pokrenut',
      stopping: 'Zaustavlja se',
      stopped: 'Isključen',
      paused: 'Pauziran',
      failed: 'U pogrešci',
      deleting: 'Briše se'
    },
    stopCause: {
      'api': 'Zaustavio ga je TVirt (radnja ili API)',
      'guest-shutdown': 'Isključivanje je pokrenuo operacijski sustav gosta',
      'crash': 'Pad gosta',
      'qemu-exit': 'Proces QEMU neočekivano je završio',
      'host-reboot': 'Čvor je ponovno pokrenut',
      'migrated': 'Migriran na drugi čvor',
      'fenced': 'Prekinuo ga je HA fencing (čvor se vratio)'
    },
    detail: {
      notFound: 'Virtualni stroj nije pronađen',
      details: 'Detalji',
      id: 'ID',
      scope: 'Scope',
      profile: 'Hardverski profil',
      firmware: 'Firmware',
      firmwareFile: 'Verzija UEFI firmwarea',
      firmwareUpdate: 'Dostupno ažuriranje',
      firmwareUpdateHint: 'Platforma isporučuje noviji UEFI firmware. Ažuriranje nikad nije automatsko: primjenjuje se dok je VM isključen, kada vi to odlučite.',
      arch: 'Arhitektura',
      node: 'Čvor',
      bootOrder: 'Redoslijed boota',
      agent: 'Status agenta',
      agentConnected: 'Povezan',
      agentNotConnected: 'Nije povezan',
      protected: 'Zaštićen',
      linkedClones: 'Povezani klonovi',
      restartPolicy: 'Politika ponovnog pokretanja',
      preferredNode: 'Preferirani čvor',
      noPreference: 'Bez preferencije (automatski placement)',
      preferNodes: 'Preferirani tagovi čvora',
      requireNodes: 'Obavezni tagovi čvora',
      noPlacementTags: 'Nijedan',
      placementTag: 'Tag',
      placementValue: 'Vrijednost',
      placementAddTag: 'Dodaj tag',
      proximityHa: 'TVirt Proximity HA',
      proximityHaRestarts: 'HA ponovnih pokretanja',
      proximityHaGaveUp: 'crash loop — HA je odustao',
      failoverProtection: 'Zaštita pri degradaciji',
      protectionProtected: 'Zaštićen',
      protectionExpendable: 'Potrošan pri degradaciji',
      protectionInherit: 'Naslijedi',
      lastStop: 'Posljednje zaustavljanje',
      yes: 'Da',
      no: 'Ne',
      tabOverview: 'Pregled',
      tabSnapshots: 'Snimke',
      tabBackups: 'Kopije',
      hardware: 'Hardver',
      name: 'Naziv',
      hwSystem: 'Sustav',
      hwCpu: 'CPU',
      hwMemory: 'Memorija',
      hwBoot: 'Pokretanje',
      hwIdentity: 'Identitet',
      hwCluster: 'Klaster i agent',
      cpuTopology: 'Topologija CPU-a',
      cpuModel: 'Model CPU-a',
      cpuLimit: 'Ograničenje CPU-a',
      cpuWeight: 'Težina CPU-a',
      cpuNested: "Ugniježđena virtualizacija",
      cpuNestedHint: "Izlaže vmx/svm gostu (samo s CPU modelom host). Na upaljenom VM-u promjena vrijedi od sljedećeg power cyclea (PendingRestart); smještaj dopušta samo čvorove s uključenim nested.",
      unlimited: 'Neograničeno',
      memory: 'Memorija',
      balloon: 'Balloon',
      hugePages: 'Velike stranice',
      hugePagesTradeoff: 'Manje posla oko prevođenja adresa i memorija koja nikad ne završava na disku; zauzvrat rezervacija ostaje zaključana na čvoru dok je VM uključen, memorija se više ne deduplicira, a pokretanje ne uspijeva ako čvor nema dovoljno slobodnih stranica.',
      disks: 'Diskovi',
      cdroms: 'CD/DVD pogoni',
      nics: 'Mrežna sučelja',
      slot: 'Slot',
      disk: 'Disk',
      encrypted: 'Šifriran',
      image: 'Slika',
      emptyDrive: 'Prazan pogon',
      emptyOption: '(prazno)',
      network: 'Mreža',
      mac: 'MAC',
      connected: 'Povezano',
      unplugged: 'Odvojeno',
      noDevices: 'Nijedan',
      screenshot: 'Snimka zaslona',
      capturedAt: 'Snimljeno',
      noCapture: 'Još nema snimke',
      snapshotName: 'Naziv',
      snapshotCreated: 'Stvorena',
      snapshotMemory: 'Memorija uključena',
      noSnapshots: 'Nema snimaka',
      pendingRestart: 'Izmjene na čekanju: primijenit će se pri sljedećem power cycleu.',
      applied: 'primijenjeno',
      appliedHint: 'VM radi s ovom vrijednošću — konfigurirana se primjenjuje pri sljedećem power cycleu.',
      actionError: 'Radnja nije uspjela',
      actionStillRunning: 'Radnja je još u tijeku: ishod još nije poznat',
      tabConsole: 'Konzola',
      consoleConnect: 'Poveži',
      consoleDisconnect: 'Odspoji',
      consoleConnecting: 'Povezivanje…',
      consoleReconnecting: 'Povezivanje…',
      consoleUnavailable: 'Konzola je dostupna dok je VM pokrenut ili pauziran.',
      consoleError: 'Povezivanje s konzolom nije uspjelo',
      consoleTaken: 'Sesiju konzole preuzeo je {user}',
      consoleReconnect: 'Ponovno poveži',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Drži pritisnuto {key}',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Otvori preko cijelog zaslona u novoj kartici',
      consoleLoadFailed: 'VM nije pronađen ili su dozvole nedostatne',
      consoleClose: 'Zatvori',
      tabStats: 'Statistika',
      tabTasks: 'Zadaci',
      tabLogs: 'Zapisnici',
      statsCpu: 'CPU',
      statsMemory: 'Memorija',
      statsDisk: 'I/O diska',
      statsRange: 'Raspon',
      statsNoData: 'Nema podataka u odabranom rasponu — statistika se uzorkuje dok je VM pokrenut.',
      statsError: 'Statistiku nije moguće učitati',
      cpuUsage: 'Iskorištenost',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Iskorišteno',
      memGuestAvailable: 'Dostupno (gost)',
      schema: 'Shema',
      consoleProtocol: 'Konzola',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Storage metapodataka',
      startupOnBoot: 'Pokretanje pri bootu',
      startupOrder: 'Redoslijed pokretanja',
      startupDelay: 'Odgoda pokretanja',
      seconds: 's',
      enabled: 'Omogućeno',
      disabled: 'Onemogućeno'
    },
    actionsAvailable: 'Dostupne radnje',
    actions: {
      start: 'Pokreni',
      stop: 'Zaustavi',
      pause: 'Pauziraj',
      resume: 'Nastavi',
      reset: 'Resetiraj',
      migrate: 'Migriraj',
      clone: 'Kloniraj',
      moveStorage: 'Premjesti na storage…',
      moveScope: 'Premjesti u scope…',
      openConsole: 'Otvori konzolu',
      forceStop: 'Prisilno isključi',
      markTemplate: 'Označi kao predložak',
      unmarkTemplate: 'Pretvori natrag u VM',
      error: 'Radnju nije moguće izvršiti'
    },
    cordon: {
      confirmTitle: 'Čvor je u održavanju',
      confirmHint:
        'Kordon se ne može spustiti dok je store klastera nedostupan. Potvrdom izjavljujete da to znate: VM se ondje ipak pokreće, a pristanak ostaje zabilježen na zadatku.',
      confirm: 'Ipak pokreni'
    },
    markTemplate: {
      confirmTitle: 'Označiti {name} kao predložak?',
      confirmBody: 'Konfiguracija se zamrzava i VM se više ne može uključiti — može se samo klonirati ili vratiti u VM. Naziv, bilješke i tagovi ostaju izmjenjivi.',
      confirm: 'Označi kao predložak',
      moved: '{name} je sada predložak — premješten je na karticu Predlošci.'
    },
    unmarkTemplate: {
      confirmTitle: 'Pretvoriti {name} natrag u VM?',
      confirmBody: 'Predložak ponovno postaje običan VM: izmjenjiv i pokretljiv (sljedeće ga pokretanje smješta na čvor).',
      confirm: 'Pretvori natrag u VM',
      moved: '{name} je ponovno virtualni stroj — premješten je na karticu Virtualni strojevi.'
    },
    nodeByTag: {
      label: 'Po tagu čvora',
      hint: 'tag=vrijednost, odvojeni zarezima (u AND-u): decider bira među odgovarajućim čvorovima',
      invalid: 'Neispravan format — koristite tag=vrijednost, odvojeno zarezima',
      resolved: 'Odgovarajući članovi: {nodes}'
    },
    migrate: {
      title: 'Live migracija',
      submit: 'Migriraj',
      target: 'Odredišni čvor',
      auto: 'Automatski (Proximity)',
      hint: 'VM se premješta bez power cyclea. Svaki storage koji dodiruje mora biti dijeljen; pauzirani VM migrira pauziran.',
      error: 'Migracija je odbijena'
    },
    moveStorage: {
      title: 'Premjesti na storage',
      submit: 'Premjesti',
      target: 'Odredišni storage',
      noTargets: 'Nijedan storage ne prihvaća diskove',
      hint: 'Svi diskovi isključenog VM-a putuju na odabrani storage, jedan po jedan, zadržavajući svoj id — oni koji su već na odredištu preskaču se. Napredak pratite na stranici zadataka.',
      error: 'Premještanje je odbijeno'
    },
    moveScope: {
      title: 'Premjesti u scope',
      submit: 'Premjesti',
      target: 'Odredišni scope',
      hint: 'VM odmah mijenja scope — id i diskovi ostaju, njegovi owned diskovi ga slijede, a može ostati uključen. Danas živi u {scope}. Tko ga vidi mijenja se sa scopeom.',
      error: 'Premještanje scopea je odbijeno'
    },
    start: {
      title: 'Pokreni VM',
      submit: 'Pokreni',
      target: 'Odredišni čvor',
      auto: 'Automatski (preporučeno)',
      recommended: 'preporučeno',
      hint: 'Odaberite odredišni čvor ili prepustite Proximityju da odluči među valjanim kandidatima. Čvorovi koji ga ne mogu ugostiti onemogućeni su, s razlogom.',
      error: 'VM nije moguće pokrenuti'
    },
    console: {
      media: 'CD/DVD pogoni',
      mediaGuestToolsHint: 'Sadrži TVirt Guest Tools — odavde ih možete izbaciti ili ukloniti pogon',
      slotOpsDeferred: 'Na ovom profilu dodavanje i uklanjanje pogona primjenjuju se pri sljedećem power cycleu (promjene medija su trenutačne).',
      mountGuestTools: 'Montiraj TVirt Guest Tools',
      ejectGuestTools: 'Izbaci TVirt Guest Tools',
      bootOrder: 'Redoslijed boota',
      bootOrderHint: 'Novi redoslijed sprema se odmah i primjenjuje pri sljedećem power cycleu — sesija konzole ostaje povezana.'
    },
    snapshots: {
      create: 'Stvori snimku',
      createTitle: 'Stvori snimku',
      createSubmit: 'Stvori',
      name: 'Naziv',
      nameHint: 'Slova, znamenke, točka, crtica, underscore.',
      consistencyHint: 'Konzistentnost je automatska: guest agent zamrzava datotečne sustave kad odgovara; inače se VM oko snimke nakratko pauzira.',
      memory: 'Uključi memoriju',
      memoryHint: 'Hvata živi RAM: vraćanje nastavlja VM pokrenut. Zahtijeva da svi diskovi budu qcow2.',
      currentChip: 'Ovdje ste',
      revert: 'Vrati',
      revertTitle: 'Vratiti na {name}?',
      revertBody: 'Diskovi se vraćaju u stanje snimke; sve što se dogodilo poslije je izgubljeno. Snimka samo diskova zahtijeva zaustavljen VM.',
      delete: 'Izbriši',
      deleteTitle: 'Izbrisati snimku {name}?',
      deleteBody: 'Točka vraćanja nestaje; sadržaj diskova ostaje netaknut.',
      deleteMergeHint: 'Njegova delta se spaja u {children}: svaka kasnija točka vraćanja ostaje valjana.',
      deleteDuplication: 'Prihvaćam dupliciranje',
      deleteDuplicationHint: 'Delta se kopira u svakog od {count} čitatelja (snapshoti djeca i, ako je ovaj trenutni, aktivna glava): zauzeti prostor može rasti umjesto da se smanjuje.',
      error: 'Operacija nad snimkom je odbijena'
    },
    clone: {
      title: 'Kloniraj VM',
      submit: 'Kloniraj',
      name: 'Naziv kopije',
      storage: 'Odredišni storage za diskove',
      sameStorage: 'Isti kao izvor',
      full: 'Potpuna kopija',
      fullHint: 'Kopira svaki bajt i kida vezu s izvornim diskovima. Zadano je linked clone: trenutačan, ali okovan uz izvor (samo qcow2).',
      hint: 'Klon zadržava konfiguraciju i firmware izvora; MAC adrese i TPM identitet su novi.',
      markAs: 'Vrsta klona',
      markAsInheritVm: 'Kao izvor (VM)',
      markAsInheritTemplate: 'Kao izvor (predložak)',
      markAsVm: 'Virtualni stroj',
      markAsTemplate: 'Predložak',
      markAsHintVm: 'Odaberite Predložak da biste kopiju promovirali u jednom koraku.',
      markAsHintTemplate: 'Odaberite Virtualni stroj da biste iz ovog predloška implementirali u jednom koraku.',
      error: 'Kloniranje je odbijeno'
    },
    bulk: {
      selected: 'odabrano',
      deleteTitle: {
        one: 'Izbrisati odabrani VM ({count})?',
        few: 'Izbrisati odabrane VM-ove ({count})?',
        other: 'Izbrisati odabrane VM-ove ({count})?'
      },
      deleteBody: 'Svaki VM prolazi iste zaštite kao i pojedinačno brisanje; odbijanja se prijavljuju po stavci.',
      done: 'prihvaćeno',
      refused: 'odbijeno'
    },
    delete: {
      button: 'Izbriši',
      confirmTitle: 'Izbrisati {name}?',
      confirmBody: 'Virtualni stroj i diskovi u njegovu vlasništvu bit će izbrisani. Radnja se ne može poništiti.',
      keepDisks: 'Zadrži diskove',
      keepDisksHint: 'Diskovi stvoreni s VM-om ostaju u svojem storageu kao samostalni diskovi.',
      confirm: 'Izbriši',
      cancel: 'Odustani',
      error: 'Brisanje nije uspjelo',
      blockedPhase: 'Najprije zaustavite VM',
      blockedProtected: 'VM je zaštićen — najprije uklonite zaštitu',
      blockedDeleting: 'Brisanje je već u tijeku'
    },
    logs: {
      title: 'Zapisnici',
      subtitle: 'Strukturirani frameovi zapisnika iz zadataka koji dodiruju ovaj VM',
      when: 'Kada',
      task: 'Zadatak',
      level: 'Razina',
      message: 'Poruka',
      empty: 'Još nema zapisa',
      loadError: 'Zapisnike nije moguće učitati — je li TVirt backend dostupan?'
    },
    stop: {
      title: 'Zaustavi virtualni stroj',
      modeGraceful: 'Graceful isključivanje',
      modeGracefulHint: 'Od operacijskog sustava gosta traži se da se uredno isključi (ACPI); ako zanemari zahtjev, nakon timeouta slijedi prisilno isključivanje.',
      modeForced: 'Prisilno isključivanje',
      modeForcedHint: 'Odmah prekida napajanje, kao izvlačenje utikača iz utičnice.',
      timeout: 'Fallback timeout (sekunde)',
      timeoutHint: 'Koliko se dugo čeka gosta prije prisilnog isključivanja'
    },
    createFromScratch: 'Ispočetka',
    createFromTemplate: 'Iz predloška',
    createQuickDeploy: 'TVirt QuickDeploy',
    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Izvrši deploy',
      error: 'Deploy nije uspio',
      compatNote: 'QuickDeploy zahtijeva predložak kompatibilan s QuickDeployem: platforma prilagođava gosta (mreža, domena, aktivacija) pri prvom pokretanju.',
      template: 'Predložak',
      noTemplates: 'Nijedan predložak još ne deklarira kompatibilnost s QuickDeployem — deklarirajte je na kartici Predlošci (Linux s cloud-initom, Windows s cloudbase-initom nakon sysprepa)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Naziv hosta',
      hostnameHint: 'Naziv hosta ili FQDN; prazno = naziv VM-a (Windows: najviše 15 znakova)',
      ip: 'IP adresa',
      ipHint: 'Host i prefiks, npr. 192.168.122.101/24; prazno = DHCP',
      gateway: 'Gateway',
      dns: 'DNS poslužitelji',
      dnsHint: 'Do tri, odvojeni zarezom',
      count: 'Instance',
      countHint: 'Više od jedne: nazivaju se <naziv>-1…-N, samo DHCP',
      user: 'Korisnik',
      userHint: 'Prazno = zadani korisnik slike (Linux) ili Administrator (Windows)',
      password: 'Lozinka',
      passwordHint: 'Zapisuje se u generirani user-data, koji platforma zatim deklarira tajnim: nitko ga više ne čita',
      sshKeys: 'Javni SSH ključevi',
      sshKeysHint: 'Jedan po retku (ssh-ed25519 AAAA… komentar)',
      productKey: 'Product key za Windows',
      kmsServer: 'KMS poslužitelj',
      kmsHint: 'Host ili host:port — zahtijeva product key (KMS klijentski ključ)',
      adDomain: 'Pridruži domeni Active Directory',
      adDomainHint: 'Prazno = bez pridruživanja domeni',
      adUser: 'Račun za pridruživanje',
      adPassword: 'Lozinka računa za pridruživanje',
      adOu: 'Odredišna OU (neobavezno)',
      advanced: 'Napredno: sirovi dokumenti',
      userData: 'user-data (sirovi)',
      userDataHint: 'Nadjačava generirani user-data: korisnik, lozinka, ključevi i Windows polja iznad moraju ostati prazni',
      networkConfig: 'network-config (sirovi)',
      networkConfigHint: 'Nadjačava generiranu mrežu: IP, gateway i DNS iznad moraju ostati prazni',
      secret: 'Tretiraj sirovi user-data kao tajnu',
      secretHint: 'Označen tajnim, API ga više nikome ne vraća i u Checkpointu putuje zapečaćen masterpassom',
      startNow: 'Pokreni odmah',
      startNowHint: 'Svaka instanca se pokreće čim je definirana; seed nastaje pri tom pokretanju'
    },
    create: {
      nicAttachmentNetwork: 'Logička mreža (fabric)',
      nicNetwork: 'Logička mreža',
      nicNetworkHint: 'PREPORUČENI put (F3): vNIC se ostvaruje na IZVEDENOM bridgeu poslužujućeg čvora — bridge se rađa pri eksplicitnom fabric applyju, a pokretanje na čvoru koji ga još ne nosi odbija govoreći. Kad ode zadnja referenca flote, bridge ispada pri sljedećem applyju.',
      button: 'Stvori VM',
      title: 'Stvori virtualni stroj',
      dialogTitle: 'Stvori virtualni stroj',
      stepGeneral: 'Općenito',
      stepGeneralHint: 'Naziv i profil',
      stepCompute: 'CPU i RAM',
      stepComputeHint: 'Topologija i veličine',
      stepDisks: 'Diskovi',
      stepDisksHint: 'Stvori ili priključi',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Pogoni i mediji',
      stepNetwork: 'Mreža',
      stepNetworkHint: 'NIC-ovi: trunk ili bridge',
      stepSummary: 'Sažetak',
      stepSummaryHint: 'Pregledaj i stvori',
      name: 'Naziv',
      nameHint: 'Mala slova, znamenke i crtice (DNS-1123)',
      nextButton: 'Dalje',
      prevButton: 'Natrag',
      submitButton: 'Stvori',
      creating: 'Stvaranje…',
      sockets: 'Socketi',
      cores: 'Jezgre po socketu',
      threads: 'Threadovi po jezgri',
      totalVcpus: 'Ukupno vCPU',
      memoryGib: 'Memorija (GiB)',
      cpuModelHint: "'host' izlaže CPU hosta",
      cpuLimitHint: 'Gornja granica u jezgrama hosta — prazno = neograničeno',
      cpuNestedHint: "Izlaže vmx/svm gostu kako bi mogao pokretati vlastiti hipervizor — zahtijeva CPU model host i čvor s uključenim nested",
      newDisk: 'Novi disk',
      attachDisk: 'Priključi postojeći disk',
      diskStorage: 'Storage',
      diskSize: 'Veličina (GiB)',
      diskSelect: 'Disk',
      addDisk: 'Dodaj disk',
      addCdrom: 'Dodaj CD/DVD pogon',
      addNic: 'Dodaj mrežno sučelje',
      remove: 'Ukloni',
      slotLimit: 'Dosegnuto je ograničenje slotova',
      cdromImage: 'Slika (prazan pogon ako je nema)',
      nicAttachment: 'Priključak',
      nicAttachmentTrunk: 'Overlay trunk',
      nicAttachmentBridge: 'Host bridge',
      nicUntagged: 'Untagged overlay',
      nicUntaggedNone: 'Nijedan (samo tagged)',
      nicTrunkHint: 'Barem jedna strana: untagged overlay i/ili tagged VLAN mapiranja — VM može raditi samo na hostovima koje deklarira svaki referencirani overlay',
      nicTaggedVlan: 'VLAN ID',
      nicTaggedOverlay: 'Overlay mreža',
      addTagged: 'Dodaj tagged VLAN',
      nicBridge: 'Naziv host bridgea',
      nicBridgeHint: 'NM bridge po nazivu — VM može raditi samo na poslužiteljima čiji host network deklarira ovaj bridge',
      nicMac: 'MAC (automatski ako je prazno)',
      noDisksHint: 'Nema diskova: VM će imati samo CD/DVD pogone koje dodate.',
      noCdromsHint: 'Nema CD/DVD pogona: dodajte jedan za pokretanje s ISO slike.',
      mountGuestTools: 'Montiraj TVirt Guest Tools pri prvom pokretanju',
      mountGuestToolsHint: 'Stavlja ISO s virtio driverima i guest agentom u prazan CD pogon (dodan po potrebi) — Windows installeru trebaju da bi vidio svoje diskove.',
      noNicsHint: 'Nema mrežnih sučelja: VM će se pokrenuti bez povezivosti.',
      taggedMappings: 'Tagged VLAN mapiranja',
      summaryDevices: 'Uređaji',
      bootOrderTitle: 'Redoslijed boota',
      bootOrderHint: 'Povucite za promjenu redoslijeda — pobjeđuje prvi uređaj s kojeg se može pokrenuti; NIC-ovi pokreću PXE',
      bootOrderUp: 'Pomakni gore',
      bootOrderDown: 'Pomakni dolje',
      createError: 'Stvaranje nije uspjelo'
    },
    edit: {
      button: 'Uredi',
      title: 'Uredi virtualni stroj',
      cancel: 'Odustani',
      save: 'Spremi',
      error: 'Uređivanje nije uspjelo',
      modelStoppedOnly: 'Izmjenjivo samo dok je VM isključen',
      firmwareStoppedOnly: 'Firmware je izmjenjiv samo dok je VM isključen — pri sljedećem pokretanju stroj kreće s novim firmwareom, a UEFI varijable ostaju',
      hugePagesStoppedOnly: 'Izmjenjivo samo dok je VM isključen — pri sljedećem pokretanju memorija nastaje na novom backingu',
      runningHint: 'Izmjene se primjenjuju pri sljedećem power cycleu',
      sectionCpu: 'CPU',
      sectionMemory: 'Memorija',
      sectionPolicy: 'Politike'
    },
    devices: {
      networkChip: 'fabric mreža',
      title: 'Uređaji',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Dodaj USB uređaj',
      addUsbTitle: 'Zatraži klasu USB uređaja',
      usbClassHint:
        'VM traži KLASU USB uređaja (vrijednost taga usb-device), nikad konkretan uređaj: pri pokretanju se na čvoru bira i rezervira konkretan slobodan uređaj. Registrirane uređaje tagirajte pod Klaster › USB i PCIe resursi.',
      usbTag: 'Tag (usb-device)',
      usbValue: 'Vrijednost klase',
      noUsbTags: 'Nema tagova usb-device — stvorite jedan i tagirajte registrirane uređaje pod Klaster › USB i PCIe resursi.',
      noUsbValues: 'Ovaj tag još nema deklariranih vrijednosti.',
      usbEmpty: 'Nema USB zahtjeva — dodajte klasu da bi se uređaj proslijedio pri pokretanju.',
      usbClassChip: 'klasa',
      usbPortChip: 'port',
      usbUnclaimed: 'Nijedan uređaj nije rezerviran — razrješava se pri pokretanju VM-a.',
      addGpu: 'Dodaj GPU',
      addGpuTitle: 'Zatraži klasu GPU-a',
      gpuClassHint:
        'VM traži KLASU GPU-a (vrijednost taga gpu-device), nikad konkretnu karticu: pri pokretanju se na čvoru bira i rezervira konkretna slobodna kartica, a CIJELA njezina IOMMU grupa prolazi zajedno. Registrirane GPU-ove tagirajte pod Klaster › USB i PCIe resursi.',
      gpuTag: 'Tag (gpu-device)',
      gpuValue: 'Vrijednost klase',
      noGpuTags: 'Nema tagova gpu-device — stvorite jedan i tagirajte registrirane GPU-ove pod Klaster › USB i PCIe resursi.',
      noGpuValues: 'Ovaj tag još nema deklariranih vrijednosti.',
      gpuEmpty: 'Nema GPU zahtjeva — dodajte klasu da bi se kartica proslijedila pri pokretanju.',
      gpuClassChip: 'klasa',
      gpuGroupChip: 'IOMMU grupa ×',
      gpuUnclaimed: 'Nijedna kartica nije rezervirana — razrješava se pri pokretanju VM-a.',
      gpuPowerCycle: 'Nema GPU hotpluga — izmjene vrijede od sljedećeg power cyclea (PendingRestart)',
      actions: 'Radnje',
      attachDisk: 'Dodaj disk',
      attachDiskTitle: 'Dodaj disk',
      attach: 'Priključi',
      noFreeDisks: 'Nema nekorištenih diskova — stvorite jedan pod Virtualni strojevi › Nekorišteni diskovi.',
      addCdrom: 'Dodaj pogon',
      addCdromTitle: 'Dodaj CD/DVD pogon',
      editCdromTitle: 'Promijeni CD/DVD sliku',
      changeMedia: 'Promijeni CD/DVD sliku',
      ejectMedium: 'Izbaci',
      mountGuestTools: 'Montiraj TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools su montirani',
      guestToolsClickMount: 'Stavlja TVirt Guest Tools ISO u prvi prazan CD/DVD pogon',
      guestToolsClickUnmount: 'Kliknite za izbacivanje — pogon ostaje, prazan',
      guestToolsNoSlot: 'Nema praznog CD/DVD pogona — dodajte pogon (ili izbacite medij) da biste montirali TVirt Guest Tools',
      guestToolsSkew: 'Montirano v{pinned}; čvor {node} sada poslužuje v{current}: izbaci i ponovno montiraj za ažuriranje',
      ejectGuestTools: 'Izbaci TVirt Guest Tools (pogon ostaje, prazan)',
      guestToolsEjectConfirmTitle: 'Izbaciti TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'Medij se izbacuje iz uključenog VM-a — CD/DVD pogon ostaje, prazan.',
      applyLive: 'Primijeni odmah (VM je uključen)',
      addNic: 'Dodaj sučelje',
      addNicTitle: 'Dodaj mrežno sučelje',
      editNicTitle: 'Uredi mrežno sučelje',
      bridgeChip: 'bridge',
      cable: 'Virtualni kabel',
      plug: 'Priključi virtualni kabel',
      unplug: 'Odvoji virtualni kabel',
      remove: 'Ukloni',
      removeTitle: 'Ukloniti {device}?',
      removeBody: 'Na uključenom VM-u izmjena se primjenjuje pri sljedećem power cycleu. Diskovi i slike se odvajaju, nikad ne brišu.'
    }
  }
}
